import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col category-checkbox" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import http from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

interface Props {
  // カテゴリー
  categories: Array<number>;
}
const REAGENT = 1;

// 全体量
const ALL_BULK = 100;

// カテゴリー
interface CheckBoxOption {
  [props: string]: unknown;
  label: string;
  value: unknown;
  disable?: boolean | undefined;
}

// 試薬

export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryCheckBox',
  props: {
    categories: {}
  },
  emits: ['change'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const router = useRouter();

const emit = __emit;

// 試薬
const categoriesComputed = computed({
  get: () => props.categories,
  set: (value) => {
    if (value.length !== 0) {
      if (value[0] === REAGENT && value[value.length - 1] !== REAGENT) {
        value.shift();
      } else if (value[0] !== REAGENT && value[value.length - 1] === REAGENT) {
        value.splice(0, value.length - 1);
      }
    }
    emit('change', value);
  },
});

// チェックボックス
const reagentOptions = ref<Array<CheckBoxOption>>([]);
// 大量品
const bulkOptions = ref<Array<CheckBoxOption>>([]);

const allBulkOptions = ref<Array<CheckBoxOption>>([]);

const allBulkSelect = computed({
  get: () => props.categories,
  set: (value) => {
    if (value.length !== 0) {
      if (value[0] === REAGENT && value[value.length - 1] !== REAGENT) {
        value.shift();
      }
    }
    if (value[value.length - 1] === ALL_BULK) {
      for (let i = 0; i < bulkOptions.value.length; i += 1) {
        value.push(Number(bulkOptions.value[i].value));
      }
    } else {
      value.splice(0, value.length);
    }
    emit('change', value);
  },
});

// カテゴリー取得
const getCategories = () => {
  http
    .post('/csr002001/category')
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        // システムエラー
        router.push({ name: 'error' });
      }
      response.data.categoryAllItems.forEach(
        (category: { sup_category_id: number; sup_category: string }) => {
          // 試薬の場合
          if (category.sup_category_id === REAGENT) {
            reagentOptions.value.push({
              value: category.sup_category_id,
              label: category.sup_category,
            });
          } else {
            bulkOptions.value.push({
              value: category.sup_category_id,
              label: category.sup_category,
            });
          }
        }
      );
      allBulkOptions.value.push({
        value: ALL_BULK,
        label: 'バルク一括チェック',
      });
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// 初期表示処理
getCategories();

return (_ctx: any,_cache: any) => {
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "co1-2 category-checkbox-category-label flex items-center" }, [
      _createElementVNode("label", null, "カテゴリー")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_option_group, {
        modelValue: categoriesComputed.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((categoriesComputed).value = $event)),
        options: reagentOptions.value,
        color: "primary",
        type: "checkbox",
        inline: "",
        class: "category-med"
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_q_option_group, {
        modelValue: allBulkSelect.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((allBulkSelect).value = $event)),
        options: allBulkOptions.value,
        color: "primary",
        type: "checkbox",
        inline: "",
        class: "category-allbulk"
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_q_option_group, {
        modelValue: categoriesComputed.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((categoriesComputed).value = $event)),
        options: bulkOptions.value,
        color: "primary",
        type: "checkbox",
        inline: "",
        class: "category-other"
      }, null, 8, ["modelValue", "options"])
    ])
  ]))
}
}

})